import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { associateLogout } from 'store/actions/app'
import './Header.scss'
import ReactTooltip from 'react-tooltip'
import { useTranslation } from 'react-i18next'
import ThemeModeButton from 'components/ThemeModeButton'

import {
    Message,
    Button,
    Menu,
    Icon,
    Popup,
    Image,
    Grid,
    Label,
    Header,
    Segment,
} from 'semantic-ui-react'

const getAvatar = (associate) => {
    let name = 'Guest'
    if (associate) {
        name = associate?.code
    }
    return `https://ui-avatars.com/api/?name=${name}`
}

const AssociateHeader = (props) => {
    const { t } = useTranslation()
    const {
        associate,
        associateLogout,
        setExpand,
        openModal,
        setOpenModal,
        mobileOnly,
        previousExpand,
        setPreviousExpand,
        expand,
    } = props
    const isSidebarExpanded = mobileOnly ? expand === 1 : expand == null || expand === 1
    const [modalVisible, setModalVisible] = useState(false)

    let userName = associate?.name ?? ''

    return (
        <>
            <Menu
                className='NavBar__Header'
                inverted
                borderless
                size='tiny'
                attached='top'
                fixed='top'
                style={{
                    // desplazar solo en desktop cuando el lateral está expandido (null o 1)
                    left: !mobileOnly && (isSidebarExpanded) ? 225 : 0,
                    width: !mobileOnly && (isSidebarExpanded) ? 'calc(100% - 225px)' : '100%',
                    transition: 'left 0.8s ease, width 0.8s ease',
                    boxShadow: '10px 1px 12px 0px rgba(0,0,0,0.10)',
                }}
            >
                <Menu className='SubMenu__Header' size='mini' secondary>
                    {(mobileOnly || !isSidebarExpanded) && (
                        <Menu.Item className='NavBar__Item NavBar__SidebarToggle'>
                            <img
                                src='https://img.icons8.com/?size=100&id=g5dx3VExcn2X&format=png&color=000000'
                                alt={t('Lista')}
                                className='NavBar__Item NavBar__SidebarToggle'
                                style={{
                                    width: 24,
                                    height: 24,
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    verticalAlign: 'middle',
                                }}
                                onClick={() => {
                                    setExpand((previousExpandedState) => {
                                        setPreviousExpand(previousExpandedState)

                                        if (!mobileOnly)
                                            return previousExpandedState == 1
                                                ? previousExpand == null || previousExpand == 2
                                                    ? 0
                                                    : 2
                                                : 1

                                        return !previousExpandedState ? 1 : 0
                                    })
                                }}
                            />
                        </Menu.Item>
                    )}
                    <Menu.Item className='NavBar__Brand'>
                        <Header>
                            <h4 className='NavBar__Outline'>Geo Transport</h4>
                            <Header.Subheader className='NavBar__Outline'>
                                V 0.19.63
                            </Header.Subheader>
                        </Header>
                    </Menu.Item>
                    <Menu.Item fitted position='right'>
                        <img
                            data-tip
                            data-for='help-tooltip'
                            src='https://img.icons8.com/?size=100&id=p4rXi9HURgXT&format=png&color=000000' // <-- reemplaza por la URL/prop de Icons.js
                            alt={t('Ayuda')}
                            className='NavBar__Item'
                            style={{ width: 25, height: 25, cursor: 'pointer' }}
                            onClick={() => { setOpenModal(!openModal) }}
                        />
                    </Menu.Item>
                    <ReactTooltip id='help-tooltip' place='top' effect='solid' className='tooltip-mini' offset={{ right: 2 }}>
                        {t('Ayuda')}
                    </ReactTooltip>
                </Menu>
                <Menu.Menu position={mobileOnly ? null : 'right'} size='tiny'>
                    <Menu.Item fitted position='right' className='NavBar__Item'>
                        <Popup
                            onOpen={() => setModalVisible(true)}
                            onClose={() => setModalVisible(false)}
                            pinned
                            on='click'
                            trigger={
                                <Menu.Item className='NavBar__Item' style={{ marginRight: '25px' }}>
                                    <Image src={getAvatar(associate)} avatar />
                                    <span style={{ color: 'var(--bgtextcolor)', fontSize: '14px' }}>{(associate?.user || associate?.name || '').slice(0, 10)}</span>
                                </Menu.Item>
                            }
                            content={
                                <Segment className='NavBar__Outline'>
                                    <Grid
                                        divided='vertically'
                                        columns='equal'
                                        className='Header_PopUp'
                                        style={{ display: 'inline-block', padding: 0 }}
                                    >
                                        <Grid.Row columns={1}>
                                            <Grid.Column
                                                verticalAlign='middle'
                                                textAlign='center'
                                                className='Logout__Item'
                                            >
                                                <Image
                                                    className='Header_PopUp_Image'
                                                    src={getAvatar(associate)}
                                                    avatar
                                                />
                                            </Grid.Column>
                                            <Grid.Column
                                                verticalAlign='middle'
                                                textAlign='center'
                                                className='Logout__Item'
                                            >
                                                <h4 className='NavBar__InvertedOutline'>
                                                    {userName.toUpperCase()}
                                                </h4>
                                            </Grid.Column>
                                            <Grid.Column
                                                verticalAlign='middle'
                                                textAlign='center'
                                                className='Logout__Item'
                                            >
                                                <Button
                                                    className='Header_PopUp_Button'
                                                    basic
                                                    icon
                                                    labelPosition='right'
                                                    onClick={async () => {
                                                        await associateLogout()
                                                        props.history.push('/login_superadmin')
                                                    }}
                                                >
                                                    <Icon name='sign out' />
                                                    {t('Cerrar sesión')}
                                                </Button>
                                            </Grid.Column>
                                            <Grid.Column
                                                verticalAlign='middle'
                                                className='Logout__Item'
                                                style={{ display: 'flex', justifyContent: 'center' }}
                                            >
                                                <ThemeModeButton />
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Segment>
                            }
                            position='bottom right'
                        />
                    </Menu.Item>
                </Menu.Menu>
            </Menu>
        </>
    )
}

const mapDispatchToProps = (dispatch) => ({
    associateLogout: () => dispatch(associateLogout()),
})

const mapStateToProps = (state) => ({
    associate: state.app?.superAdmin?.associate,
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssociateHeader))
